import React from "react";
import classes from "./TermsPage.module.css";

const TermsPage = () => {
  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        
        <header className={classes.header}>
          <h1>Terms & Conditions</h1>
          <p>Please read these terms carefully before using Agriczone services.</p>
        </header>

        <div className={classes.card}>
          <ul className={classes.termsList}>
            <li>
              This is a subscription-based Service providing digital content to mobile users.
            </li>
            <li>
              The service is available to eligible prepaid subscribers.
            </li>
            <li>
              Applicable subscription charges will be deducted from the user’s airtime balance.
            </li>
            <li>
              The service is auto-renewable and renewal charges apply as per the subscribed plan.
            </li>
            <li>
              Users may unsubscribe at any time by using the unsubscribe option in the portal, without any additional charges.
            </li>
          </ul>

          {/* <div className={classes.footerNote}>
            <p>
              By subscribing to Agriczone, you acknowledge that you have read and agreed to these terms.
            </p>
          </div> */}
        </div>

      </div>
    </div>
  );
};

export default TermsPage;